/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bubble_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create a bubble chart from X,Y,size data — three variables at once, no sign-up.`)
};

const es_bubble_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea un gráfico de burbujas a partir de datos X,Y,tamaño — tres variables a la vez, sin registro.`)
};

const de_bubble_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstellen Sie ein Blasendiagramm aus X,Y,Größe-Daten — drei Variablen auf einmal, keine Anmeldung erforderlich.`)
};

const nl_bubble_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maak een bellendiagram van X,Y,grootte-data — drie variabelen tegelijk, geen registratie nodig.`)
};

const fr_bubble_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créez un graphique à bulles à partir de données X,Y,taille — trois variables à la fois, sans inscription.`)
};

const it_bubble_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea un grafico a bolle da dati X,Y,dimensione — tre variabili contemporaneamente, senza registrazione.`)
};

const pt_br2_bubble_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crie um gráfico de bolhas a partir de dados X,Y,tamanho — três variáveis de uma vez, sem cadastro.`)
};

const pt_bubble_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crie um gráfico de bolhas a partir de dados X,Y,tamanho — três variáveis de uma vez, sem registo.`)
};

const ja_bubble_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`X, Y, サイズのデータからバブルチャートを作成します — 3つの変数を同時に表示、登録不要。`)
};

const zh_bubble_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`根据 X,Y,大小 数据创建气泡图——一次展示三个变量，无需注册。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bubble_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bubble_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bubble_tool_description", locale)
	if (locale === "en") return en_bubble_tool_description(inputs)
	if (locale === "es") return es_bubble_tool_description(inputs)
	if (locale === "de") return de_bubble_tool_description(inputs)
	if (locale === "nl") return nl_bubble_tool_description(inputs)
	if (locale === "fr") return fr_bubble_tool_description(inputs)
	if (locale === "it") return it_bubble_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_bubble_tool_description(inputs)
	if (locale === "pt") return pt_bubble_tool_description(inputs)
	if (locale === "ja") return ja_bubble_tool_description(inputs)
	return zh_bubble_tool_description(inputs)
};